export const unitSelector = [
    {title:'cm', value:'cm'},
    {title:'kg', value:'kg'},
    {title:'V(voltio)', value:'V(voltio)'},
    {title:'SI/NO', value:'SI/NO'},
]